import angular from 'angular'
import checkStreams from './checkStreams'
import importSetting from './importSetting'
import ovatBillRule from './ovatBillRule'
import preWarn from './preWarn'
import inputRule from './inputRule'
import templateSetting from './templateSetting'
import reportTemplateSetting from './reportTemplateSetting'
import templateSetUp from './templateSetUp'
import rollticketSpec from './rollticketSpec'
import systemParams from './systemParams'
import externalSystem from './externalSystem'
import portSetUp from './portSetUp'
import printParams from './printParams'
import personalTaxConfiguration from './personalTaxConfiguration'
import taxDeclarationConfig from './taxDeclarationConfig'

export default angular
  .module('system.settingcenter', [
    checkStreams,
    importSetting,
    ovatBillRule,
    preWarn,
    inputRule,
    templateSetting,
    reportTemplateSetting,
    templateSetUp,
    rollticketSpec,
    portSetUp,
    systemParams,
    externalSystem,
    printParams,
    personalTaxConfiguration,
    taxDeclarationConfig,
  ])
  .config([
    '$stateProvider',
    function config($stateProvider) {
      $stateProvider.state('system.settingcenter', {
        abstract: true,
        url: '/settingcenter',
        template: '<div ui-view></div>',
        title: '设置中心',
      })
    },
  ]).name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/index.js